import { Link } from "react-router-dom/cjs/react-router-dom";

export default function ProfileSidebar({ activeTab, setActiveTab }) {
  const tabs = [
    "Profile Settings",
    "Balance",
    "Allocation",
    "Portfolio Breakdown",
    "Price Movement",
  ];

  return (
    <>
      <aside className="hidden md:inline-block w-full max-w-[241px] min-h-[576px] rounded-lg border border-[#BFBFBF] bg-[#2727270F] p-6 shadow-custom3 font-poppins">
        <h2 className="mb-4 text-base font-bold">My Account</h2>
        <nav className="flex flex-col items-start space-y-6 text-sm mt-10">
          {tabs?.map((tab) => {
            const isSelectable =
              tab === "Balance" || tab === "Profile Settings";

            return (
              <Link
                key={tab}
                to="#"
                onClick={() => {
                  if (isSelectable) {
                    setActiveTab(tab);
                  }
                }}
                className={`font-medium text-sm pb-1 transition-colors ${
                  activeTab === tab
                    ? "border-b-2 border-black"
                    : "border-b-2 border-transparent"
                } ${
                  isSelectable
                    ? "cursor-pointer hover:text-black"
                    : "text-gray-400 cursor-not-allowed"
                }`}
              >
                {tab}
              </Link>
            );
          })}
        </nav>
      </aside>

      <div className="flex md:hidden mb-4 overflow-x-auto">
        {tabs?.map((tab) => {
          const isSelectable = tab === "Balance" || tab === "Profile Settings";
          return (
            <button
              key={tab}
              onClick={() => {
                if (isSelectable) {
                  setActiveTab(tab);
                }
              }}
              className={`px-4 py-2 text-sm font-medium whitespace-nowrap transition-colors ${
                activeTab === tab
                  ? "border-b-2 border-black"
                  : "border-b-2 border-transparent"
              } ${
                isSelectable
                  ? "cursor-pointer hover:text-black"
                  : "text-gray-400 cursor-not-allowed"
              }`}
            >
              {tab}
            </button>
          );
        })}
      </div>
    </>
  );
}
